import { stringify } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";
import { stringifyQs } from "../utils/urls";

export const shipmentSection = "/shipment/";

export const shipmentListPath = shipmentSection;

export type shipmentListUrlDialog = "publish" | "unpublish" | TabActionDialog;

export enum shipmentListUrlFiltersEnum {
  query = "query"
}

export enum shipmentListUrlSortField {
  name = "name",
  email = "email",
  orders = "orders",
  shipedDelivered = "shipedDelivered",
  shipedDate = "shipedDate",
  trackingCode = "trackingCode",
  orderNumber = "orderNumber",
  trackingNumber = "trackingNumber"
}

export type shipmentListUrlFilters = Filters<shipmentListUrlFiltersEnum>;

export type shipmentListUrlSort = Sort<shipmentListUrlSortField>;

export type shipmentListUrlQueryParams = ActiveTab &
  BulkAction &
  shipmentListUrlFilters &
  shipmentListUrlSort &
  Dialog<shipmentListUrlDialog> &
  Pagination;

export const shipmentListUrl = (params?: shipmentListUrlQueryParams) =>
  shipmentListPath + "?" + stringify(params);

export type shipmentUrlDialog =
  | "remove"
  | "assign"
  | "unassignTag"
  | "add-tag"
  | "unassign"
  | "updateTag";

export type shipmentPathUrlQueryParams = BulkAction &
  Dialog<shipmentUrlDialog> &
  SingleAction &
  Pagination;

export const shipmentPath = (id: string) => urlJoin(shipmentSection, id);

export const shipmentUrl = (id: string, params?: shipmentPathUrlQueryParams) =>
  shipmentPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
